import { CaretDown, CaretUp } from '@phosphor-icons/react';
import { SVG_SIZE_M } from 'src/constants';
import { Button } from 'src/v2/commonComponents/Button';
import styles from './SelectorButton.module.scss';
import { Icon, IconName } from 'src/components/Icon';
import { Icon as IconComponent } from '@phosphor-icons/react';

interface SelectorButtonProps {
  id: string;
  disabled?: boolean;
  onClick: () => void;
  label?: string;
  isActive?: boolean;
  icon?: IconName;
  IconComponent?: IconComponent;
  className?: string;
}

export const SelectorButton = ({
  id,
  disabled,
  onClick,
  label,
  isActive,
  icon,
  IconComponent,
  className,
}: SelectorButtonProps) => {
  return (
    <Button
      id={id}
      disabled={disabled}
      color={isActive ? 'tertiary-outline' : 'secondary-outline'}
      onClick={onClick}
      fullWidth
      className={className}
    >
      <div className={styles.valueWrapper}>
        {icon && <Icon type={icon} size={SVG_SIZE_M} />}
        {IconComponent && <IconComponent size={SVG_SIZE_M} />}
        <span className={styles.label}>{label}</span>
      </div>
      {isActive ? (
        <CaretUp size={SVG_SIZE_M} />
      ) : (
        <CaretDown size={SVG_SIZE_M} />
      )}
    </Button>
  );
};
